import { createContext, useContext, useEffect, useState } from "react";
import { endpoints, getAccessToken } from "../../../service/api";
import { isMobile, isTablet, isDesktop } from "react-device-detect";
import { UAParser } from "ua-parser-js";
import axios from "axios";
import { QrPageTranslatedTextsJson } from "../../../assets/texts/QrPageTranslatedTexts";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [qrPageTranslatedTexts, setQrPageTranslatedTexts] = useState(QrPageTranslatedTextsJson.es);

  const getAuthToken = async () => {
    if (!token) {
      const accessToken = await login();
      return accessToken;
    }
    return token;
  };

  const getDeviceInfo = () => {
    if (isMobile) return "Mobile";
    if (isTablet) return "Tablet";
    if (isDesktop) return "Desktop";
    return "Unknown";
  };

  const getBrowserInfo = () => {
    const parser = new UAParser();
    const browser = parser.getBrowser();
    return `${browser.name} ${browser.version}`;
  };

  const getIPAddress = async () => {
    try {
      const response = await axios.get("https://api.ipify.org?format=json");
      return response.data.ip;
    } catch (error) {
      console.error("Error fetching IP address:", error);
      return null;
    }
  };

  const setTranslatedTextsByLanguage = (language) => {
    setQrPageTranslatedTexts(QrPageTranslatedTextsJson[language]);
  };

  const login = async () => {
    const response = await getAccessToken(endpoints.getAccessToken);
    if (response.ok) {
      const responseData = await response.json();
      setToken(responseData.accessToken);

      return responseData.accessToken;
    }
  };

  return (
    <AuthContext.Provider
      value={{
        getAuthToken,
        getDeviceInfo,
        getBrowserInfo,
        getIPAddress,
        setTranslatedTextsByLanguage,
        qrPageTranslatedTexts,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
